import {useEffect, useState} from 'react'
import {CoursePatientInfo} from '../../../../Adaptor/TUBSIS/controllers/Courses/models/getCoursePatientInfoByCourseIdModels'
import {PatientCard} from './PatientCard'
import {getCourseStatusByUserId} from '../../../../Adaptor/TUBSIS'
import {GetCourseOutput} from '../../../../Adaptor/TUBSIS/controllers/Courses/models/getCourseModels'
import {ModuleWidget} from '../../../customPartials/widgets/ModuleWidget'

type Props = {
  patient: CoursePatientInfo | null
}
const PatientStatus: React.FC<Props> = ({patient}) => {
  const [curUserState, setCurUserState] = useState<GetCourseOutput | null>(null)
  useEffect(() => {
    ////debugger
    if (patient?.userId) {
      ////debugger
      getCourseStatusByUserId(patient?.userId)
        .then((response) => {
          ////debugger
          setCurUserState(response.data)
        })
        .catch((error) => {
          ////debugger
          console.log(error)
        })
    }
  }, [patient])
  let newList = []
  if (curUserState?.modules) {
    for (let i = 0; i < curUserState?.modules.length; i++) {
      const obj = curUserState?.modules[i]
      const row = parseInt((i / 2).toString())
      if (newList.filter((x) => x.row === row).length === 0) {
        newList.push({row: row, modules: [obj]})
      } else {
        newList.find((x) => x.row === row)?.modules.push(obj)
      }
    }
  }
  let Percent = curUserState?.courseCompletionPercent ?? 0
  let ChartColor =
    Percent < 26 ? 'danger' : Percent < 51 ? 'warning' : Percent < 91 ? 'success' : 'primary'
  return (
    <>
      {patient && (
        <div className='flex-lg-row-fluid ms-lg-7 ms-xl-10'>
          <div className='card' id='kt_chat_messenger'>
            <div className='card-header' id='kt_chat_messenger_header w-full'>
              <div className='card-title w-full '>
                {/* <div className='d-flex justify-content-center flex-column me-3'> */}
                {/* <div className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                    {`${patient?.name} ${patient?.surname}`}
                  </div> */}
                <div>
                  <PatientCard patient={patient} />
                </div>

                {/* </div> */}
              </div>

              {/* <div className='card-toolbar'>
              <div className='me-n3'>
                <button
                  className='btn btn-sm btn-icon btn-active-light-primary'
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                  data-kt-menu-flip='top-end'
                >
                  <i className='bi bi-three-dots fs-2'></i>
                </button>
                <Dropdown1 />
              </div>
            </div> */}
            </div>
            <div>
              <div>
                {newList.map((x, index) => (
                  <div className='row g-5 g-xl-8' key={'rw' + index}>
                    {x.modules.map((y) => (
                      <div className='col-xl-6' key={'modulew' + y.id}>
                        <ModuleWidget
                          className='card-xl-stretch mb-xl-8'
                          chartHeight='200px'
                          title={y.title}
                          titleDesc={y.titleDescription}
                          desc={y.description}
                          module={y}
                          moduleId={y.id}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export {PatientStatus}
